import {
  globalAxios,
  backendVersion,
  managerInstance,
  merchantInstance,
} from "@/axios-path.js";
import axios from "axios";

export default {
  namespaced: true,
  state: {
    userData: [],
    userMerchantList: [],
    indexEditLoading: null,
    settransactionById: [],
    settransactionInvoice: {},
    settransactionProfit: {},
    settransactionWithdraw: {}
  },
  mutations: {
    resetState(state) {
      state.userData = [];
    },
    getData(state, data) {
      state.userData = data;
    },
    deleteUser(state, item) {
      const index = state.userData.indexOf(item);
      state.userData.splice(index, 1);
    },
    addUser(state, user) {
      state.userData.push(user);
    },
    editing(state, index) {
      state.indexEditLoading = index;
    },
    setUserMerchantList(state, data) {
      state.userMerchantList = data;
    },
    settransactionById(state, res) {
      state.settransactionById = res;
    },
    settransactionInvoice(state, res) {
      state.settransactionInvoice = res;
    },
    settransactionProfit(state, res) {
      state.settransactionProfit = res;
    },
    settransactionWithdraw(state, res) {
      state.settransactionWithdraw = res;
    },
  },
  actions: {
    async setUserToVIP(
      { dispatch },
      { user_id, user_level_status, otp_pin, otp_ref, otp_tel, create_at }
    ) {
      let url = "/api/v1/Setupvip";
      let payload = {
        user_id,
        user_level_status,
        otp_verified: true,
        otp_pin: otp_pin,
        otp_ref: otp_ref,
        otp_tel: otp_tel,
      };
      return globalAxios
        .put(url, payload)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async verifyOTP({ dispatch }, { pin, ref, tel }) {
      let url = "/api/v1/backoffiec/OTPVerification";
      let payload = {
        pin: pin,
        tel: tel,
        ref: ref,
      };
      return globalAxios
        .post(url, payload)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async sendOTP({ dispatch }, { tel }) {
      let url = "/api/v1/backoffiec/SentOTP";
      let payload = {
        country_tel: "66",
        tel: tel,
      };
      return globalAxios
        .post(url, payload)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async getData({ commit, state, dispatch }) {
      state.userData = [];
      state.indexEditLoading = null;
      let url = backendVersion.version + "/users";
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getData", res);
        return "No data available";
      }
    },

    async fetchManagerUserList({ }, config) {
      let url = backendVersion.version + "/partner/get_list_user_partner";
      return managerInstance
        .get(url, { params: config })
        .then((data) => {
          return data.data;
        })
        .catch((err) => {
          return [];
        });
    },

    async fetchtransactionByid({ commit }, { manager_id }) {
      let url = `${backendVersion.version
        }/partner/get_transaction_manager_backoffice/${manager_id}`;
      return managerInstance
        .get(url)
        .then((res) => {
          if (res.msg == false) return false;
          commit("settransactionById", res.data);
          return res.data;
        })
        .catch(() => {
          return false;
        });
    },
    async fetchtransactionInvoice({ commit }, { invoice_id }) {
      let url = `${backendVersion.version
        }/partner/get_transaction_detail_manager_backoffice/${invoice_id}/Invoice`;
      return managerInstance
        .get(url)
        .then((res) => {
          if (res.msg == false) return false;
          commit("settransactionInvoice", res.data);
          return res.data;
        })
        .catch(() => {
          return false;
        });
    },

    async fetchtransactionProfitBill({ commit }, { profit_id }) {
      let url = `${backendVersion.version
        }/partner/get_transaction_detail_manager_backoffice/${profit_id}/Order`;
      return managerInstance
        .get(url)
        .then((res) => {
          if (res.msg == false) return false;
          commit("settransactionProfit", res);
          return res.data;
        })
        .catch(() => {
          return false;
        });
    },
    async fetchtransactionWithdrawBill({ commit }, { profit_id }) {
      let url = `${backendVersion.version
        }/partner/get_transaction_detail_manager_backoffice/${profit_id}/Withdraw`;
      return managerInstance
        .get(url)
        .then((res) => {     
          if (res.msg == false) return false;
          commit("settransactionWithdraw", res.data);
          return res.data;
        })
        .catch(() => {
          return false;
        });
    },
    async deleteUser({ commit, dispatch }, item) {
      let url = backendVersion.version + "/delete/user/" + item.user_id;
      let res = await dispatch("fetchGeneral/coreInstanceDeleteData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("deleteUser", item);
      }
    },
    async addUser({ commit, dispatch }, userInfo) {
      let url = backendVersion.version + "/backoffice/register";
      let res = await dispatch(
        "fetchGeneral/coreInstancePostData",
        { url, form: userInfo },
        { root: true }
      );
      if (res === false) {
        return false;
      } else {
        commit("addUser", res);
        return true;
      }
    },
    async addManagerUser({ commit, dispatch }, payload) {
      let url = backendVersion.version + "/partner/register";
      return managerInstance
        .post(url, payload)
        .then(() => {
          return true;
        })
        .catch(() => {
          return false;
        });
    },
    async editManagerUser({ commit, dispatch }, payload) {
      let url = backendVersion.version + "/partner/update_user_partner";
      return managerInstance
        .put(url, payload)
        .then(() => {
          return true;
        })
        .catch(() => {
          return false;
        });
    },
    async changePasswordManager({ commit, dispatch }, payload) {
      let url = backendVersion.version + "/partner/reset_password_partner";
      return managerInstance
        .put(url, payload)
        .then(() => {
          return true;
        })
        .catch(() => {
          return false;
        });
    },
    async checkManagerTel({ }, configPath) {
      let url = backendVersion.version + "/partner/check_user_partner_tel";
      return managerInstance
        .get(url, { params: configPath })
        .then((data) => {
          if (data.msg == false) return false;
          return true;
        })
        .catch((err) => {
          return false;
        });
    },
    async deleteManager({ commit }, id) {
      let url = backendVersion.version + "/partner/delete_user_partner/" + id;
      return managerInstance
        .delete(url)
        .then((data) => {
          if (data.msg == false) return false;
          return true;
        })
        .catch((err) => {
          return false;
        });
    },
    async changePasswordUser({ dispatch }, sendData) {
      let url =
        backendVersion.version + "/backoffice/repassword/" + sendData.user_id;
      let res = await dispatch(
        "fetchGeneral/coreInstancePutData",
        { url, form: sendData },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        alert("ไม่สามารถเปลี่ยนรหัสผ่านได้");
      } else {
      }
    },
    async editUser({ commit, dispatch }, userInfo) {
      let url = backendVersion.version + "/edit/user/" + userInfo.user_id;
      let res = await dispatch(
        "fetchGeneral/coreInstancePutData",
        { url, form: userInfo },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        commit("editing", null);
        return "error";
      } else {
        commit("editing", null);
        return "completed";
      }
    },
    async getAllUserMerchant({ dispatch, commit }) {
      let url = backendVersion.version + "/merChant/all_users";
      let res = await dispatch("fetchGeneral/merchantGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return 0;
      } else {
        console.log(res);
        commit("setUserMerchantList", res.data);
        return res;
      }
    },
    fetchSessionByUserMerchantTel({ }, userTel) {
      let url = backendVersion.version + "/merChant/check_token_by_tel";
      let payload = {
        user_tel: userTel,
      };
      return merchantInstance
        .post(url, payload)
        .then((data) => {
          if (data.msg == false) return [];
          return data.data;
        })
        .catch((err) => {
          return [];
        });
    },
    validateMerchantDeviceToken({ }, deviceToken) {
      let url = `https://iid.googleapis.com/iid/info/${deviceToken}`;
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "key=AAAAMiBaZ0g:APA91bEuROxZz7GsfScnlBobLlSzx4CWFV9VQIi6tOlg7AANRt2fbpzkWxwkhduMvICUrAc8PYpFj_pwv91rKyhFOfAfdj6sUdT2ma8cLr-OPdgU6hgL0I-EungmI0M8wKDZnsl1oMHx",
        },
      };
      return axios
        .get(url, axiosConfig)
        .then((res) => {
          if (res.status == 200) {
            return alert(
              `applicationVersion: ${res.data.applicationVersion
              }\napplication: ${res.data.application}\nplatform: ${res.data.platform
              }`
            );
          }
          return alert(`ไม่พบข้อมูล`);
        })
        .catch((err) => alert(`ไม่พบข้อมูล`));
    },
    testMerchantOrderNotification({ }, deviceToken) {
      let url = "https://fcm.googleapis.com/fcm/send";
      let payload = {
        registration_ids: [deviceToken],
        priority: "high",
        notification: {
          title: "ทดสอบระบบเสียงออเดอร์",
          body: "You have received an order.",
          sound: "ordernotinew.caf",
          android_channel_id: "noti_push_app_1",
        },
        data: {
          notification_foreground: "true",
        },
      };
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "key=AAAAMiBaZ0g:APA91bEuROxZz7GsfScnlBobLlSzx4CWFV9VQIi6tOlg7AANRt2fbpzkWxwkhduMvICUrAc8PYpFj_pwv91rKyhFOfAfdj6sUdT2ma8cLr-OPdgU6hgL0I-EungmI0M8wKDZnsl1oMHx",
        },
      };
      return axios
        .post(url, payload, axiosConfig)
        .then((res) => {
          if (res.status == 200 && res.data.success == 1) {
            return alert("ส่งการทดสอบการแจ้งเตือนแล้ว");
          }
          return alert(`ทดสอบไม่สำเร็จ\n${JSON.stringify(res.data)}`);
        })
        .catch((err) => console.log(err));
    },
    setDefaultPaymentManager({ }, payload) {
      let url =
        backendVersion.version + "/partner/create_user_partner_default_payment";
      return managerInstance
        .post(url, payload)
        .then((res) => {
          if (res.msg == false) return false;
          return res.data;
        })
        .catch(() => {
          return false;
        });
    },
  },
  getters: {},
};
